module.exports = __webpack_public_path__ + "img/gauge-1.e0b00006.svg";